// 模板 3：医疗健康数字化平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '医疗机构一体化信息平台',
        content:
          '打通门诊、住院、药房与检查科室的数据链路，提升医疗服务质量与效率。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '以患者为中心的服务体验',
        content:
          '通过线上服务入口与智能分诊工具，让患者就医流程更加顺畅便捷。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '临床与运营数据一体化',
      subtitle: '/ Healthcare Data Hub',
      paragraphs: [
        '通过整合 HIS、LIS、PACS 等系统数据，为院方提供临床与运营一体化视图，支撑精细化管理。',
        '预置多种医疗指标模型，帮助管理者掌握病种结构、资源利用率与费用构成等关键指标。'
      ],
      buttonText: '预约医院方案咨询'
    },
    contact: {
      title: '可信赖的医疗信息化合作伙伴',
      subTitle: '用技术守护生命安全，用数据支撑科学决策',
      buttonText: '联系医疗顾问'
    },
    customers: [
      {
        logo: require('@/assets/img/logo_hp.png'),
        title: '三甲医院 · 信息中心主任',
        content:
          '平台帮助我们整合了多套业务系统的数据，院领导可以实时查看关键运营指标，决策效率明显提升。'
      }
    ],
    advantages: [
      {
        icon: require('@/assets/img/computer.png'),
        title: '符合医疗规范',
        html: '<p>遵循医疗行业标准</p>兼顾数据安全与业务连续性'
      },
      {
        icon: require('@/assets/img/qiniu.png'),
        title: '稳定可靠架构',
        html: '<p>适配医院复杂网络环境</p>保障关键业务系统稳定运行'
      }
    ]
  },
  company: {
    name: '和康医疗数字科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__长期专注医院与医疗集团的信息化与数字化建设，提供覆盖临床业务与运营管理的一体化产品体系。',
      '团队成员具备多年三甲医院项目经验，熟悉医疗安全与合规要求，致力于用稳定可靠的平台支撑医疗质量持续提升。'
    ]
  },
  news: [
    {
      id: 'M01',
      title: '区域医疗影像中心项目顺利上线',
      introduce:
        '公司承建的区域医疗影像中心在多家医院正式上线，实现影像资源共享与远程会诊，缓解患者“重复检查”问题。',
      date: '05-18',
      year: '2024'
    },
    {
      id: 'M02',
      title: '携手医院共建质控指标体系',
      introduce:
        '公司与多家医院合作梳理临床质控指标，结合数据平台能力打造实时质控看板，辅助医院提升医疗质量管理能力。',
      date: '11-02',
      year: '2023'
    },
    {
      id: 'M03',
      title: '护理移动查房系统全面部署',
      introduce:
        '依托移动终端，护理人员可以在床旁完成医嘱核对与护理记录录入，大幅提升工作效率并降低差错率。',
      date: '07-09',
      year: '2023'
    },
    {
      id: 'M04',
      title: '医院运营数据分析研讨会成功举办',
      introduce:
        '公司联合多家医院举办运营数据分析专题研讨会，分享数据驱动下的精细化管理实践。',
      date: '03-21',
      year: '2022'
    },
    {
      id: 'M05',
      title: '加入智慧医疗产业联盟',
      introduce:
        '作为技术服务商，公司正式加入智慧医疗产业联盟，与产业伙伴共同探索医疗数字化新路径。',
      date: '09-30',
      year: '2021'
    }
  ],
  software: {
    smartTown: {
      title: '智慧医院运营平台 · 场景概览',
      sections: [
        {
          heading: '1. 门急诊一体化监控',
          content:
            '实时掌握门急诊患者量、候诊时间与关键检查排队情况，辅助医院合理调配资源，缓解就诊高峰压力。'
        },
        {
          heading: '2. 住院床位与手术排期管理',
          content:
            '以可视化方式呈现床位占用与手术排期情况，帮助科室协调资源，提升床位周转效率。'
        },
        {
          heading: '3. 医院后勤与设备运维',
          content:
            '围绕耗材、设备与后勤保障建立统一管理体系，提升资产利用率并降低运维成本。'
        },
        {
          heading: '4. 区域协同与远程医疗',
          content:
            '通过远程会诊、检查互认等能力，帮助上级医院下沉优质资源，提升区域整体诊疗水平。'
        }
      ]
    },
    bigData: {
      title: '医疗数据治理与分析',
      sections: [
        {
          heading: '1. 患者全生命周期视图',
          desc:
            '整合患者在院内多次就诊记录，形成完整的就诊轨迹，为临床决策与科研分析提供可靠数据基础。'
        },
        {
          heading: '2. 运营成本与效益分析',
          desc:
            '通过费用结构、资源利用率与服务质量等指标，帮助管理者平衡成本控制与服务体验。'
        },
        {
          heading: '3. 质控与安全监测',
          desc:
            '围绕重点病种与关键诊疗环节，实时监测质控指标异常，辅助医院降低医疗风险。'
        },
        {
          heading: '4. 科研数据支撑',
          desc:
            '为科研团队提供规范化的数据脱敏与取数工具，降低数据使用门槛，加速科研项目推进。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '医院信息化总体规划',
      engTitle: 'eHealth Planning',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '平台实施与培训',
      engTitle: 'Implementation & Training',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '运维托管与值班服务',
      engTitle: 'Managed IT Service',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '医疗数据咨询',
      engTitle: 'Healthcare Data Consulting',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '医疗信息化实施顾问',
    responsibilities: [
      '参与医院信息化项目实施全过程，负责需求调研、方案配置与上线支持；',
      '协助医院用户完成系统培训与操作指导，整理项目文档与经验沉淀；',
      '在项目过程中主动识别风险与问题，推动多方协同解决。'
    ],
    requirements: [
      '了解医院业务流程，有医疗信息化或相关行业项目经验者优先；',
      '具备良好的沟通能力与服务意识，能够适应一定频次的出差；',
      '学习能力强，愿意持续了解医疗政策与行业发展趋势。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-3.js